import { get } from "lodash";
import postForm from "@irati/utils/PostForm";
import { SAML_REQUEST_TYPE_POST, SAML_REQUEST_TYPE_REDIRECT } from "../constants/signUpOptions";
import { samlInitiateLogin } from "../services/sso";
export var initiateSamlLogin = function (tenant) {
    var singleSignOnPopUp = window.open("/empty-loader.html", "singleSignOnWindow", "width=400, height=600");
    return new Promise(function (resolve, reject) {
        if (!singleSignOnPopUp) {
            return reject("Popup failed to load");
        }
        var handleSuccess = function (details) {
            var userId = get(details, "data.user.uuid");
            var access_token = get(details, "data.access_token");
            var userTenant = get(details, "data.tenant");
            if (userId && access_token && userTenant) {
                singleSignOnPopUp.close();
                resolve(details.data);
                window.removeEventListener("message", handleSuccess);
            }
        };
        samlInitiateLogin(tenant).then(function (data) {
            var _a;
            if (!data.SAMLRequestName || !data.SAMLRequestValue) {
                singleSignOnPopUp.location = data.SAMLRequestURL;
            }
            else if (data.SAMLRequestType === SAML_REQUEST_TYPE_REDIRECT) {
                var querySymbol = data.SAMLRequestURL.includes("?") ? "&" : "?";
                /* eslint-disable max-len */
                singleSignOnPopUp.location.href = "" + data.SAMLRequestURL + querySymbol + data.SAMLRequestName + "=" + data.SAMLRequestValue;
                /* eslint-enable max-len */
            }
            else if (data.SAMLRequestType === SAML_REQUEST_TYPE_POST) {
                var form = postForm(data.SAMLRequestURL, (_a = {}, _a[data.SAMLRequestName] = data.SAMLRequestValue, _a));
                form.target = "singleSignOnWindow";
                form.submit();
            }
            window.addEventListener("message", handleSuccess);
        });
    });
};
